import React from 'react';
import reactDom from './react/dom/index';
import VideoEventiCorrelatiContainer from '../components/common/VideoEventiCorrelatiContainer';

export default function init() {
	reactDom(<VideoEventiCorrelatiContainer />, 'js-react-videoEventiCorrelati');
}
